import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDfZyKVlxfLtHSUsXMuqViFop_Z3gLcoF4",
  authDomain: "havk-app.firebaseapp.com",
  databaseURL: "https://havk-app.firebaseio.com",
  projectId: "havk-app",
  storageBucket: "havk-app.appspot.com",
  messagingSenderId: "26517136542",
  appId: "1:26517136542:web:7d4e4f2fda3249db42078f",
  measurementId: "G-C03BC6VXB4",
});

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const message = firebase.messaging();

export { db, auth, storage, message };
